var _line, _line2, _line3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 0.5,
    x2: 19,
    y2: 0.5,
    stroke: "currentColor"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 6.5,
    x2: 19,
    y2: 6.5,
    stroke: "currentColor"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 12.5,
    x2: 19,
    y2: 12.5,
    stroke: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxOSAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGxpbmUgeTE9IjAuNSIgeDI9IjE5IiB5Mj0iMC41IiBzdHJva2U9ImN1cnJlbnRDb2xvciIvPgo8bGluZSB5MT0iNi41IiB4Mj0iMTkiIHkyPSI2LjUiIHN0cm9rZT0iY3VycmVudENvbG9yIi8+CjxsaW5lIHkxPSIxMi41IiB4Mj0iMTkiIHkyPSIxMi41IiBzdHJva2U9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgIcMenu as ReactComponent };